import "core-js/modules/es.object.keys";
//
//
//
//
import * as echarts from 'echarts';
export default {
  name: 'echartsContainer',
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      myChart: null
    };
  },
  watch: {
    option: {
      handler: function handler(newVal) {
        if (newVal && this.myChart) {
          this.myChart.setOption(newVal, true);
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);

    if (this.myChart) {
      this.myChart.dispose();
      this.myChart = null;
    }
  },
  methods: {
    initChart: function initChart() {
      if (!this.$refs.chartRef) return;
      this.myChart = echarts.init(this.$refs.chartRef);

      if (this.option && Object.keys(this.option).length > 0) {
        this.myChart.setOption(this.option);
      }
    },
    handleResize: function handleResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    }
  }
};